

export enum RouteName {
    EquipmentList = '/equipment',
    EquipmentTemplate = '/templates',
    MaintenancePlan = '/maintenance-plan',
    // Calibration page started with /work-order/:woId
    Calibration = '/work-order'
}
